/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Sync_Title4Inputs */

const en_svc_ai_voice_agents_sync_title4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM and calendar sync`)
};

const ar_svc_ai_voice_agents_sync_title4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المزامنة مع CRM والتقويم`)
};

const bn_svc_ai_voice_agents_sync_title4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM আর ক্যালেন্ডার সিঙ্ক`)
};

const de_svc_ai_voice_agents_sync_title4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM- und Kalendersynchronisation`)
};

const es_svc_ai_voice_agents_sync_title4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización con CRM y calendario`)
};

const fr_svc_ai_voice_agents_sync_title4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisation CRM et calendrier`)
};

const pt_svc_ai_voice_agents_sync_title4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronização com CRM e calendário`)
};

const zh_svc_ai_voice_agents_sync_title4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM 与日历同步`)
};

const tr_svc_ai_voice_agents_sync_title4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRM ve takvim senkronu`)
};

const ru_svc_ai_voice_agents_sync_title4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизация с CRM и календарём`)
};

const pl_svc_ai_voice_agents_sync_title4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronizacja z CRM i kalendarzem`)
};

/**
* | output |
* | --- |
* | "CRM and calendar sync" |
*
* @param {Svc_Ai_Voice_Agents_Sync_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_sync_title4 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Sync_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Sync_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_sync_title4(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_sync_title4(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_sync_title4(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_sync_title4(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_sync_title4(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_sync_title4(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_sync_title4(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_sync_title4(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_sync_title4(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_sync_title4(inputs)
	return en_svc_ai_voice_agents_sync_title4(inputs)
});
export { svc_ai_voice_agents_sync_title4 as "svc_ai-voice-agents_SYNC_title" }